import { PiDotsThree } from "react-icons/pi";

const KpiSummaryCard = ({ title, subtitle, target, onMenuClick }) => {
  return (
    <div className="bg-white rounded-lg p-5 shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
      <div className="space-y-4">
        <div className="rounded-lg p-4 border border-gray-200 min-h-[80px] flex flex-col justify-center">
          <h4 className="text-sm font-semibold text-black mb-1">{title}</h4>
          <p className="text-xs text-gray-500">{subtitle}</p>
        </div>
        
        <div className="flex items-center justify-between min-h-[24px]">
          <span className="text-sm font-semibold text-black">{target}</span>
          <button
            onClick={onMenuClick}
            className="p-1 hover:bg-gray-100 rounded transition flex-shrink-0"
          >
            <PiDotsThree className="w-4 h-4 text-gray-400" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default KpiSummaryCard;
